<template>
    <div id="container" type="vbuyingpower">
        <div class="page page-buyingpower" v-ga:request="{pageType:'vbuyingpower', state: {}}" v-ga:page="{pageType:'vbuyingpower', glb: glb, state: {}}">
            <mvtHeader />
            <section class="inline large">
                <div class="fixed fixed-max-sm grid xs-grid-cols-1 gap-3">
                    <div class="text-center">
                        <h1><b class="f0 text-bold">Know Your Buying Power</b></h1>
                    </div>
                    <div class="buying-power-section flex large wrap stretch">
                        <div class="flex-xs-12 flex-sm-12 flex-md-8 flex-lg-8">
                            <div class="combined-form flex inline bg-default corner">
                                <div class="buying-power-form">
                                    <form class="grid xs-grid-cols-1 form" novalidate>
                                        <div class="input">
                                            <label>Annual Income</label>
                                            <mvtInputNumber v-model="annualIncome" maxlength="20" :prefix="'$'" />
                                        </div>
                                        <div class="input">
                                            <label>Down Payment</label>
                                            <mvtInputNumber v-model="downPayment" maxlength="20" :prefix="'$'" />
                                        </div>
                                        <div class="input">
                                            <label>Monthly Debts Payments</label>
                                            <mvtInputNumber v-model="monthlyDebts" maxlength="20" :prefix="'$'" />
                                        </div>
                                        <div class="input">
                                            <label>ZIP Code</label>
                                            <input type="text" v-model.lazy="zipcode" v-validate="'required|zipcode'" maxlength="5" v-valueChange="zipcode" />
                                        </div>
                                    </form>
                                </div>

                                <div class="buying-power-info">
                                    <div class="monthly-payment-label">You can afford a home up to:</div>
                                    <div class="monthly-payment-value">
                                        <span class="text-bold">{{ $filters.formatPrice(homePrice) }}</span>
                                    </div>
                                    <div class="affordability-range">
                                        <input type="range" min="20" max="50" v-model="dti" class="slider" />
                                    </div>
                                    <div class="affordability-milestones">
                                        <span>Affordable</span>
                                        <span>Stretching</span>
                                        <span>Aggressive</span>
                                    </div>
                                    <hr />
                                    <div>
                                        <div>Total Monthly Payment</div>
                                        <div>
                                            <span class="f4 text-bold">{{ $filters.formatPrice(pricePerMonth) }}</span>
                                        </div>
                                    </div>
                                    <div class="process-bar">
                                        <div v-for="item in chartData" :style="{ width: item.value}" :type="item.key"></div>
                                    </div>
                                    <div class="info">
                                        <div v-for="item in chartData">
                                            <label :type="item.key"></label>
                                            <div v-if="item.key==='Interest'">Principal & Interest</div>
                                            <div v-else-if="item.key==='Taxes'">Property Taxes</div>
                                            <div v-else-if="item.key==='HOA'">Monthly HOA Fee</div>
                                            <div v-else-if="item.key==='PMI'">Mortgage Insurance</div>
                                            <div v-else-if="item.key==='Insurance'">Insurance</div>
                                            <b>{{ $filters.formatPrice(item.price) }}</b>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div  class="flex-xs-12 flex-sm-12 flex-md-4 flex-lg-4">
                            <div class="pre-approved inline corner wrap center">
                                <div class="f2 text-bold">Next Step: <br />Get Preapproved</div>
                                <div class="info">Now that you’ve estimated your affordability, get preapporved today with a lender to find out how much you can borrow.</div>
                                <div class="pre-approved-nav">
                                    <div class="input">
                                        <input
                                            v-model.lazy="zipcode"
                                            ref="zipcode"
                                            name="zipcode"
                                            v-validate="'required|zipcode'"
                                            type="text"
                                            placeholder="ZIP Code"
                                            maxlength="5"
                                            v-valueChange="zipcode"
                                        />
                                    </div>
                                    <button class="btn primary regular" @click="preApprovalPage($event)">Get Started</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section class="inline large">
                <mvtLazyload>
                    <mvtRateTrend></mvtRateTrend>
                </mvtLazyload>
            </section>

            <mortgageTools :id="glb.pageType" preTitle="EXPERT GUIDANCE AND RESOURCES" title="Explore More Mortgage Tools"></mortgageTools>

            <section class="inline large">
                <div class="grid fixed fixed-max-sm xs-grid-cols-1">
                    <div class="text-center">
                        <h2>
                            <b class="f3 text-bold">Frequently Asked Questions</b>
                        </h2>
                    </div>
                    <mvtFaq v-if="faqQuery" :query="faqQuery"></mvtFaq>
                </div>
            </section>

            <section class="inline large" v-if="tag">
                <div class="grid fixed fixed-max-sm xs-grid-cols-1 gap-3">
                    <div class="text-center">
                        <b class="f3 text-bold">Tips for buying, selling or managing your home</b>
                    </div>
                    <mvtArticle :tag="tag" />
                </div>
            </section>

            <mvtFooter />
        </div>
        <mvtDialogCenter></mvtDialogCenter>
    </div>
</template>

<script src="./page-buyingpower.js"></script>

<style lang="scss">
    @use './page-buyingpower.scss' as *;
</style>
